document.querySelectorAll( '.b-accordion' ).forEach( ( block ) => {

	const accordionItems = block.querySelectorAll( '.js-accordion-item' );
	const activeItem = block.querySelector( '.js-accordion-item.is-active' );
	if ( activeItem ) {

		const activeContent = activeItem.querySelector( '.js-accordion-content' );
		activeContent.style.maxHeight = `${activeContent.scrollHeight}px`;

	}

	accordionItems.forEach( ( item ) => {

		const content = item.querySelector( '.js-accordion-content' );
		const button = item.querySelector( 'button' );

		button.addEventListener( 'click', () => {

			const isOpen = item.classList.contains( 'is-active' );

			accordionItems.forEach( ( otherItem ) => {

				const otherContent = otherItem.querySelector( '.js-accordion-content' );
				otherContent.style.maxHeight = null;
				otherItem.classList.remove( 'is-active' );

			} );

			if ( !isOpen ) {

				content.style.maxHeight = `${content.scrollHeight}px`;
				item.classList.add( 'is-active' );

			}

		} );

	} );

} );
